import { H2, Meta, Span, SubBody } from "@rikstv/shared-components";
import type React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { trackSelectSubscriptionEvent } from "~/analytics/eventTracker";
import { useBasket } from "~/components/routes/campaign/useBasket";
import type { ComparableSubscription } from "../../../../models/subscription-comparison/ComparableSubscriptions";
import type { PartnerIframeConfig } from "../../../../models/subscription-comparison/PartnerIframeConfig";
import { getPartnerIframeConfig } from "../../../routes/choose-subscription/api";
import { IframeButtonGroup } from "./IframeButtonGroup";
import "./overview-list.scss";
import { SubscriptionFeatures } from "./SubscriptionFeatures";

interface Props {
  comparableSubscriptions: ComparableSubscription[];
  partnerAlias: string;
  dwellingUnit: string;
  isMobileView: boolean;
  isIframe: boolean;
}

export const OverviewList: React.FC<Props> = ({
  comparableSubscriptions,
  partnerAlias,
  dwellingUnit,
  isMobileView,
  isIframe
}) => {
  const [iframeConfig, setIframeConfig] = useState<PartnerIframeConfig | null>(
    null,
  );
  const useBasketV2 = useBasket((s) => s.useBasketV2);

  useEffect(() => {
    if (isIframe) {
      getPartnerIframeConfig(partnerAlias).then((res) => {
        setIframeConfig(res);
      });
    }
  }, [partnerAlias, isIframe]);

  const getLinkUrl = (subscription: ComparableSubscription) =>
    useBasketV2
      ? `${subscription.campaignUrl}`
      : `/${partnerAlias}/${dwellingUnit}/${subscription.campaignUrl}`;
  
  const getTermsText = (subscription: ComparableSubscription) => subscription.optionalPriceTextMainSubscription
  ? subscription.optionalPriceTextMainSubscription
  : `Originalpris ${subscription.originalPrice},-/mnd`

  return (
    <ul className="subscriptions">
      {comparableSubscriptions.map((subscription, index) => (
        <li key={index}>
          <div className="comparable-subscription">
            <H2 lookLike="title-3">{subscription.name}</H2>
            <div>
              <p className="price">
                <Span lookLike="title-2">{subscription.currentPrice},-</Span>
                <Span lookLike="sub-body">/mnd. i {subscription.offerPeriodInMonth} mnd*</Span>
              </p>
              <Meta className="terms">{getTermsText(subscription)}</Meta>
            </div>

            <SubBody>{subscription.slogan}</SubBody>

            {iframeConfig ? (
              <IframeButtonGroup
                iframeConfig={iframeConfig}
                partnerAlias={partnerAlias}
                subscription={subscription}
              />
            ) : (
              <div className="actions">
                <Link
                  to={getLinkUrl(subscription)}
                  className="button-base primary"
                  aria-label={`Bestill ${subscription.name}`}
                  onClick={() =>
                    trackSelectSubscriptionEvent({
                      name: subscription.name,
                      campaignUrl: subscription.campaignUrl,
                      price: subscription.currentPrice,
                    })
                  }
                >
                  Bestill nå
                </Link>
              </div>
            )}

            {isMobileView && <SubscriptionFeatures subscription={subscription} />}
          </div>
        </li>
      ))}
    </ul>
  );
};
